import type { BlockCategory } from "src/types";

import { BoothTwoTone } from "@/components/icons/booth-two-tone";
import { CalendarMonthTwoTone } from "@/components/icons/calendar-month-two-tone";
import { Header } from "@/components/icons/header";
import { Media } from "@/components/icons/media";
import { People } from "@/components/icons/people";
import { Sections } from "@/components/icons/sections";
import { Stars } from "@/components/icons/stars";

export type CategoryInterface = {
  type: BlockCategory;
  title: string;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  description: string;
};

export type CategoryProps = {
  type: BlockCategory;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
};

const makeCategory = ({ type, icon }: CategoryProps): CategoryInterface => {
  const title = type.charAt(0).toUpperCase() + type.slice(1);

  return {
    type,
    title,
    icon,
    description: `${title} blocks`,
  };
};

export const categoryProps: CategoryProps[] = [
  {
    type: "header",
    icon: Header,
  },
  {
    type: "sections",
    icon: Sections,
  },
  {
    type: "sponsors",
    icon: Stars,
  },
  {
    type: "speakers",
    icon: People,
  },
  {
    type: "expo",
    icon: BoothTwoTone,
  },
  {
    type: "schedule",
    icon: CalendarMonthTwoTone,
  },
  {
    type: "media",
    icon: Media,
  },
];

const makeCategories = (categoryProps: CategoryProps[]): CategoryInterface[] =>
  categoryProps.map((categoryProps: CategoryProps) =>
    makeCategory(categoryProps)
  );

export default makeCategories;
